import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home/Home";
import Event from "./pages/Event/Event";
import MicroInvestments from "./pages/MicroInvestments/MicroInvestments";
import SuccessfulFormSubmission from "./pages/SuccessfulFormSubmission/SuccessfulFormSubmission";
import { useEffect } from "react";
import WOW from "wow.js";
import { useLocation } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Custom CSS for toast styling
const toastStyles = `
  .toastProgress {
    background: #1e3a8a !important;
  }
  .Toastify__progress-bar {
    background: #1e3a8a !important;
  }
`;

function App() {
  useEffect(() => {
    const wow = new WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 0,
      mobile: false,
      live: true,
    });
    wow.init();
  }, []);

  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <LanguageProvider>
      <style>{toastStyles}</style>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/event" element={<Event />} />
        <Route path="/mikrobefektetesek" element={<MicroInvestments />} />
        <Route
          path="/sikeres_urlapkitoltes"
          element={<SuccessfulFormSubmission />}
        />
      </Routes>
      <ToastContainer />
    </LanguageProvider>
  );
}

export default App;
